/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-08-21 17:38:48
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-02-19 14:25:38
 * @FilePath: /lobby/src/common/localStorage.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
const Key = {
  Locale: 'locale',
  Token: 'token',
  Country: 'country',
  isBonus: 'isBonus',
  StickyBanner: 'StickyBanner',
  ShowBonusTips: 'ShowBonusTips',
  cid: 'cid',
  channel: 'channel',
  shared: 'shared',
  currentReward: 'currentReward',
  clickShareIcon: 'clickShareIcon',
  clickInviteBtn: 'clickInviteBtn',
  clickEnvlopePopup: 'clickEnvlopePopup',
  todayShowed: 'todayShowed',
  BonusGamesID: 'BonusGamesID',
  isEnvelope: 'isEnvelope',
  localFrom: 'localFrom',
  agentcode: 'agentcode',
  firstdepositpopup: 'firstdepositpopup',
  PerksPlay: 'PerksPlay',
}

function setLocalStorage(key, value) {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  window?.localStorage.setItem(key, value)
}

function getLocalStorageToJson(key) {
  let item = window?.localStorage.getItem(key)
  return JSON.parse(item)
}

function getLocalStorage(key) {
  const val = window.localStorage.getItem(key)
  // console.log(`getLocalStorage key=${key} val=${val}`)
  return val ? val : ''
}

function removeLocalStorage(key) {
  window.localStorage.removeItem(key)
}

export { Key, setLocalStorage, getLocalStorage, getLocalStorageToJson, removeLocalStorage }
